enum SubModuleTypeEnum {
  Chat = 0,
}
export default Object.freeze(SubModuleTypeEnum);
